import {
  GET_LABTESTSAMPLE,
  GET_LABTESTSAMPLE_FAIL,
  GET_LABTESTSAMPLE_SUCCESS,
  GET_LABTESTSAMPLES,
  GET_LABTESTSAMPLES_FAIL,
  GET_LABTESTSAMPLES_SUCCESS,
  ADD_NEW_LABTESTSAMPLE,
  ADD_LABTESTSAMPLE_SUCCESS,
  ADD_LABTESTSAMPLE_FAIL,
  UPDATE_LABTESTSAMPLE,
  UPDATE_LABTESTSAMPLE_SUCCESS,
  UPDATE_LABTESTSAMPLE_FAIL,
  DELETE_LABTESTSAMPLE,
  DELETE_LABTESTSAMPLE_SUCCESS,
  DELETE_LABTESTSAMPLE_FAIL,
  SET_STATE_LABTESTSAMPLE,
  UPDATE_LABTESTSAMPLE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABTESTSAMPLE,
  payload: loading,
})

export const getLabTestSamples = ( params ) => ({
  type: GET_LABTESTSAMPLES,
  payload: { params },
})

export const getLabTestSamplesSuccess = (labTestSamples, totalPages, currentPage) => ({
  type: GET_LABTESTSAMPLES_SUCCESS,
  payload: { labTestSamples:labTestSamples, total:totalPages, currentPage:currentPage}
})

export const getLabTestSamplesFail = error => ({
  type: GET_LABTESTSAMPLES_FAIL,
  payload: error,
})

export const addNewLabTestSample = labTestSample => ({
  type: ADD_NEW_LABTESTSAMPLE,
  payload: labTestSample,
})

export const addLabTestSampleSuccess = labTestSample => ({
  type: ADD_LABTESTSAMPLE_SUCCESS,
  payload: labTestSample,
})  

export const addLabTestSampleFail = error => ({
  type: ADD_LABTESTSAMPLE_FAIL,
  payload: error,
})

export const updateLabTestSample = labTestSample => ({
  type: UPDATE_LABTESTSAMPLE,
  payload: labTestSample,
})

export const updateLabTestSampleStatus = labTestSample => ({
  type: UPDATE_LABTESTSAMPLE_STATUS,
  payload: labTestSample,
})

export const updateLabTestSampleSuccess = labTestSample => ({
  type: UPDATE_LABTESTSAMPLE_SUCCESS,
  payload: labTestSample,
})

export const updateLabTestSampleFail = error => ({
  type: UPDATE_LABTESTSAMPLE_FAIL,
  payload: error,
})

export const deleteLabTestSample = labTestSample => ({
  type: DELETE_LABTESTSAMPLE,
  payload: labTestSample,
})

export const deleteLabTestSampleSuccess = id => ({
  type: DELETE_LABTESTSAMPLE_SUCCESS,
  id,
})

export const deleteLabTestSampleFail = error => ({
  type: DELETE_LABTESTSAMPLE_FAIL,
  payload: error,
})

export const getLabTestSample = () => ({
  type: GET_LABTESTSAMPLE,
})

export const getLabTestSampleSuccess = labTestSample => ({
  type: GET_LABTESTSAMPLE_SUCCESS,
  payload: labTestSample,
})

export const getLabTestSampleFail = error => ({
  type: GET_LABTESTSAMPLE_FAIL,
  payload: error,
})
